import { Services } from '@smiles/voebiz-core-corporate-club';

const redirectPage = () => {
  const isLocalHost = window.location.hostname.includes('localhost');

  const redirectToUrl = window.location.replace(`${window.location.origin}/clube-smiles`);

  return isLocalHost ? null : redirectToUrl;
};

export const verifyActiveFlag = async () => {
  let isActiveFlag;

  try {
    const result = await Services.getCorporateClubFlag();

    isActiveFlag = result.data?.isCorporateClubActive;

    if (!isActiveFlag) {
      redirectPage();
      // comentar linha acima para rodar local
    }
  } catch (error) {
    console.log(error);
  }
};
